import { GetProfileActionTypes } from "./types";
let INITIAL_STATE = {
  get_profile_loading: false,
  get_profile_error: null,
  get_profile_data: null,
};

export const getProfileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetProfileActionTypes.GET_PROFILE_LOADING:
      return { ...state, get_profile_loading: true };
    case GetProfileActionTypes.GET_PROFILE_SUCCESS:
      return {
        ...state,
        get_profile_loading: false,
        get_profile_data: action.payload,
      };
    case GetProfileActionTypes.GET_PROFILE_ERROR:
      return {
        ...state,
        get_profile_loading: false,
        get_profile_error: action.payload,
      };
    default:
      return state;
  }
};
